/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/SheetGoogleConfiguration', 'model/SheetGoogleTemplateCopiedRangeSettings', 'model/SheetGenerationSettings', 'model/ExternalSourceLightSpreadsheet', 'model/PerformanceIndicatorDataReport'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/SheetGoogleConfiguration'), require('../model/SheetGoogleTemplateCopiedRangeSettings'), require('../model/SheetGenerationSettings'), require('../model/ExternalSourceLightSpreadsheet'), require('../model/PerformanceIndicatorDataReport'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.SheetGoogleConfigurationApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.SheetGoogleConfiguration, root.ForStractionServiceApi.SheetGoogleTemplateCopiedRangeSettings, root.ForStractionServiceApi.SheetGenerationSettings, root.ForStractionServiceApi.ExternalSourceLightSpreadsheet, root.ForStractionServiceApi.PerformanceIndicatorDataReport);
  }
}(this, function(ApiClient, SheetGoogleConfiguration, SheetGoogleTemplateCopiedRangeSettings, SheetGenerationSettings, ExternalSourceLightSpreadsheet, PerformanceIndicatorDataReport) {
  'use strict';

  /**
   * SheetGoogleConfiguration service.
   * @module api/SheetGoogleConfigurationApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new SheetGoogleConfigurationApi. 
   * @alias module:api/SheetGoogleConfigurationApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the sheetGoogleConfigurationAddPut operation.
     * @callback module:api/SheetGoogleConfigurationApi~sheetGoogleConfigurationAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/SheetGoogleConfiguration} body 
     * @param {module:api/SheetGoogleConfigurationApi~sheetGoogleConfigurationAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.sheetGoogleConfigurationAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sheetGoogleConfigurationAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling sheetGoogleConfigurationAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/SheetGoogleConfiguration/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sheetGoogleConfigurationCheckAuthenticationGet operation.
     * @callback module:api/SheetGoogleConfigurationApi~sheetGoogleConfigurationCheckAuthenticationGetCallback
     * @param {String} error Error message, if any.
     * @param {'Boolean'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * checkAuthentication
     * @param {String} _4SAPIAppID 
     * @param {Integer} sheetGoogleConfigurationID 
     * @param {module:api/SheetGoogleConfigurationApi~sheetGoogleConfigurationCheckAuthenticationGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Boolean'}
     */
    this.sheetGoogleConfigurationCheckAuthenticationGet = function(_4SAPIAppID, sheetGoogleConfigurationID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sheetGoogleConfigurationCheckAuthenticationGet";
      }

      // verify the required parameter 'sheetGoogleConfigurationID' is set
      if (sheetGoogleConfigurationID == undefined || sheetGoogleConfigurationID == null) {
        throw "Missing the required parameter 'sheetGoogleConfigurationID' when calling sheetGoogleConfigurationCheckAuthenticationGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'sheetGoogleConfigurationID': sheetGoogleConfigurationID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Boolean';

      return this.apiClient.callApi(
        '/SheetGoogleConfiguration/checkAuthentication', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sheetGoogleConfigurationCloneGoogleSheetGet operation.
     * @callback module:api/SheetGoogleConfigurationApi~sheetGoogleConfigurationCloneGoogleSheetGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * cloneGoogleSheet
     * @param {String} _4SAPIAppID 
     * @param {Integer} primaryKey 
     * @param {Boolean} cloneSettings 
     * @param {module:api/SheetGoogleConfigurationApi~sheetGoogleConfigurationCloneGoogleSheetGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.sheetGoogleConfigurationCloneGoogleSheetGet = function(_4SAPIAppID, primaryKey, cloneSettings, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sheetGoogleConfigurationCloneGoogleSheetGet";
      }

      // verify the required parameter 'primaryKey' is set
      if (primaryKey == undefined || primaryKey == null) {
        throw "Missing the required parameter 'primaryKey' when calling sheetGoogleConfigurationCloneGoogleSheetGet";
      }

      // verify the required parameter 'cloneSettings' is set
      if (cloneSettings == undefined || cloneSettings == null) {
        throw "Missing the required parameter 'cloneSettings' when calling sheetGoogleConfigurationCloneGoogleSheetGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'primaryKey': primaryKey,
        'cloneSettings': cloneSettings
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/SheetGoogleConfiguration/cloneGoogleSheet', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sheetGoogleConfigurationCopyRangesFromTemplatePut operation.
     * @callback module:api/SheetGoogleConfigurationApi~sheetGoogleConfigurationCopyRangesFromTemplatePutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * copyRangesFromTemplate
     * @param {String} _4SAPIAppID 
     * @param {module:model/SheetGoogleTemplateCopiedRangeSettings} body 
     * @param {module:api/SheetGoogleConfigurationApi~sheetGoogleConfigurationCopyRangesFromTemplatePutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.sheetGoogleConfigurationCopyRangesFromTemplatePut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sheetGoogleConfigurationCopyRangesFromTemplatePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling sheetGoogleConfigurationCopyRangesFromTemplatePut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/SheetGoogleConfiguration/copyRangesFromTemplate', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sheetGoogleConfigurationCreateGoogleSpreadsheetFromFinancialProfitAndLossIndicatorsGet operation.
     * @callback module:api/SheetGoogleConfigurationApi~sheetGoogleConfigurationCreateGoogleSpreadsheetFromFinancialProfitAndLossIndicatorsGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SheetGoogleConfiguration} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * createGoogleSpreadsheetFromFinancialProfitAndLossIndicators
     * @param {String} _4SAPIAppID 
     * @param {module:api/SheetGoogleConfigurationApi~sheetGoogleConfigurationCreateGoogleSpreadsheetFromFinancialProfitAndLossIndicatorsGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SheetGoogleConfiguration}
     */
    this.sheetGoogleConfigurationCreateGoogleSpreadsheetFromFinancialProfitAndLossIndicatorsGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sheetGoogleConfigurationCreateGoogleSpreadsheetFromFinancialProfitAndLossIndicatorsGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = SheetGoogleConfiguration;

      return this.apiClient.callApi(
        '/SheetGoogleConfiguration/createGoogleSpreadsheetFromFinancialProfitAndLossIndicators', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sheetGoogleConfigurationCreateGoogleSpreadsheetFromIndicatorsPut operation.
     * @callback module:api/SheetGoogleConfigurationApi~sheetGoogleConfigurationCreateGoogleSpreadsheetFromIndicatorsPutCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SheetGoogleConfiguration} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * createGoogleSpreadsheetFromIndicators
     * @param {String} _4SAPIAppID 
     * @param {module:model/SheetGenerationSettings} body 
     * @param {Boolean} createForecastSheet 
     * @param {module:api/SheetGoogleConfigurationApi~sheetGoogleConfigurationCreateGoogleSpreadsheetFromIndicatorsPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SheetGoogleConfiguration}
     */
    this.sheetGoogleConfigurationCreateGoogleSpreadsheetFromIndicatorsPut = function(_4SAPIAppID, body, createForecastSheet, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sheetGoogleConfigurationCreateGoogleSpreadsheetFromIndicatorsPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling sheetGoogleConfigurationCreateGoogleSpreadsheetFromIndicatorsPut";
      }

      // verify the required parameter 'createForecastSheet' is set
      if (createForecastSheet == undefined || createForecastSheet == null) {
        throw "Missing the required parameter 'createForecastSheet' when calling sheetGoogleConfigurationCreateGoogleSpreadsheetFromIndicatorsPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'createForecastSheet': createForecastSheet
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = SheetGoogleConfiguration;

      return this.apiClient.callApi(
        '/SheetGoogleConfiguration/createGoogleSpreadsheetFromIndicators', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sheetGoogleConfigurationDeleteGet operation.
     * @callback module:api/SheetGoogleConfigurationApi~sheetGoogleConfigurationDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} primaryKey 
     * @param {module:api/SheetGoogleConfigurationApi~sheetGoogleConfigurationDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.sheetGoogleConfigurationDeleteGet = function(_4SAPIAppID, primaryKey, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sheetGoogleConfigurationDeleteGet";
      }

      // verify the required parameter 'primaryKey' is set
      if (primaryKey == undefined || primaryKey == null) {
        throw "Missing the required parameter 'primaryKey' when calling sheetGoogleConfigurationDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'primaryKey': primaryKey
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/SheetGoogleConfiguration/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sheetGoogleConfigurationEditPut operation.
     * @callback module:api/SheetGoogleConfigurationApi~sheetGoogleConfigurationEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/SheetGoogleConfiguration} body 
     * @param {Integer} primaryKey 
     * @param {module:api/SheetGoogleConfigurationApi~sheetGoogleConfigurationEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.sheetGoogleConfigurationEditPut = function(_4SAPIAppID, body, primaryKey, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sheetGoogleConfigurationEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling sheetGoogleConfigurationEditPut";
      }

      // verify the required parameter 'primaryKey' is set
      if (primaryKey == undefined || primaryKey == null) {
        throw "Missing the required parameter 'primaryKey' when calling sheetGoogleConfigurationEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'primaryKey': primaryKey
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/SheetGoogleConfiguration/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sheetGoogleConfigurationGetLightGoogleSpreadsheetGet operation.
     * @callback module:api/SheetGoogleConfigurationApi~sheetGoogleConfigurationGetLightGoogleSpreadsheetGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ExternalSourceLightSpreadsheet} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * getLightGoogleSpreadsheet
     * @param {String} _4SAPIAppID 
     * @param {Integer} sheetGoogleConfigurationID 
     * @param {module:api/SheetGoogleConfigurationApi~sheetGoogleConfigurationGetLightGoogleSpreadsheetGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ExternalSourceLightSpreadsheet}
     */
    this.sheetGoogleConfigurationGetLightGoogleSpreadsheetGet = function(_4SAPIAppID, sheetGoogleConfigurationID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sheetGoogleConfigurationGetLightGoogleSpreadsheetGet";
      }

      // verify the required parameter 'sheetGoogleConfigurationID' is set
      if (sheetGoogleConfigurationID == undefined || sheetGoogleConfigurationID == null) {
        throw "Missing the required parameter 'sheetGoogleConfigurationID' when calling sheetGoogleConfigurationGetLightGoogleSpreadsheetGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'sheetGoogleConfigurationID': sheetGoogleConfigurationID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ExternalSourceLightSpreadsheet;

      return this.apiClient.callApi(
        '/SheetGoogleConfiguration/getLightGoogleSpreadsheet', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sheetGoogleConfigurationImportAndProcessGoogleSheetsDataGet operation.
     * @callback module:api/SheetGoogleConfigurationApi~sheetGoogleConfigurationImportAndProcessGoogleSheetsDataGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/PerformanceIndicatorDataReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * importAndProcessGoogleSheetsData
     * @param {String} _4SAPIAppID 
     * @param {Integer} sheetGoogleConfigurationID 
     * @param {module:api/SheetGoogleConfigurationApi~sheetGoogleConfigurationImportAndProcessGoogleSheetsDataGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/PerformanceIndicatorDataReport>}
     */
    this.sheetGoogleConfigurationImportAndProcessGoogleSheetsDataGet = function(_4SAPIAppID, sheetGoogleConfigurationID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sheetGoogleConfigurationImportAndProcessGoogleSheetsDataGet";
      }

      // verify the required parameter 'sheetGoogleConfigurationID' is set
      if (sheetGoogleConfigurationID == undefined || sheetGoogleConfigurationID == null) {
        throw "Missing the required parameter 'sheetGoogleConfigurationID' when calling sheetGoogleConfigurationImportAndProcessGoogleSheetsDataGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'sheetGoogleConfigurationID': sheetGoogleConfigurationID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [PerformanceIndicatorDataReport];

      return this.apiClient.callApi(
        '/SheetGoogleConfiguration/importAndProcessGoogleSheetsData', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sheetGoogleConfigurationLoadAllGet operation.
     * @callback module:api/SheetGoogleConfigurationApi~sheetGoogleConfigurationLoadAllGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/SheetGoogleConfiguration>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAll
     * @param {String} _4SAPIAppID 
     * @param {module:api/SheetGoogleConfigurationApi~sheetGoogleConfigurationLoadAllGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/SheetGoogleConfiguration>}
     */
    this.sheetGoogleConfigurationLoadAllGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sheetGoogleConfigurationLoadAllGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [SheetGoogleConfiguration];

      return this.apiClient.callApi(
        '/SheetGoogleConfiguration/loadAll', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
